import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=dba2ba94&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports